interface SectionProps {
  id: string;
  title: string;
  children: React.ReactNode;
}

export function Section({ id, title, children }: SectionProps): React.ReactElement {
  return (
    <section id={id} className="scroll-mt-4 rounded-lg border bg-card p-4">
      <h2 className="text-sm font-semibold uppercase tracking-wider text-muted-foreground mb-3">{title}</h2>
      {children}
    </section>
  );
}

export function FieldLabel({ children }: { children: React.ReactNode }): React.ReactElement {
  return <dt className="text-xs font-medium text-muted-foreground">{children}</dt>;
}

export function FieldValue({ children }: { children: React.ReactNode }): React.ReactElement {
  return <dd className="text-sm mt-0.5">{children ?? <span className="text-muted-foreground">—</span>}</dd>;
}

export function FieldPair({ label, value }: { label: string; value: React.ReactNode }): React.ReactElement {
  return (
    <div>
      <FieldLabel>{label}</FieldLabel>
      <FieldValue>{value || "—"}</FieldValue>
    </div>
  );
}

export function TextBlock({
  label,
  value,
}: {
  label: string;
  value: string | null | undefined;
}): React.ReactElement | null {
  if (!value) return null;
  return (
    <div>
      <h3 className="text-sm font-medium text-muted-foreground mb-1">{label}</h3>
      <p className="text-sm whitespace-pre-wrap">{value}</p>
    </div>
  );
}
